import request from '@/utils/request'

//////////////////////用户管理///////////////////////////////
//登录
export function login(params) {
    return request({
        url: 'api/user/login',
        method: 'post',
        params
    })
}

//图形验证码  api/user/captcha
export function captcha() {
    return request({
        url: 'api/user/captcha',
        method: 'get'
    })
}
// 发送短信
export function sendapi(params) {
    return request({
        url: 'api/sms/send',
        method: 'post',
        params
    })
}
//注册方法 api/User/register
export function register(params) {
    return request({
        url: 'api/User/register',
        method: 'post',
        params
    })
}

//用户详情  api/user/getUserInfo
export function getUserInfo() {
    return request({
        url: 'api/user/getUserInfo',
        method: 'get'
    })
}

//发送短息 api/user/sendVerificationCode?mobile=15632683131
export function sendVerificationCode(params) {
    return request({
        url: 'api/user/sendVerificationCode',
        method: 'get',
        params
    })
}

//忘记密码，重置密码  api/user/resetPassword
export function resetPassword(params) {
    return request({
        url: 'api/user/resetPassword',
        method: 'post',
        params
    })
}

//修改密码 api/user/changePassword
export function changePassword(params) {
    return request({
        url: 'api/user/changePassword',
        method: 'post',
        params
    })
}

//我的证书 api/user/cert?name=2132&cert_no=131423123
export function getCert(params) {
    return request({
        url: 'api/user/cert',
        method: 'get',
        params
    })
}

//首页接口
export function postHome() {
    return request({
        url: 'api/index/index',
        method: 'post'
    })
}

//联系我们
export function contact() {
    return request({
        url: 'api/config/contact',
        method: 'post'
    })
}

//分类列表
export function cateList(params) {
    return request({
        url: 'api/index/cate_list',
        method: 'get',
        params
    })
}

//分类详情       版权申明id=18
export function cateDetail(params) {
    return request({
        url: 'api/index/getCategoryDetail',
        method: 'get',
        params
    })
}

//列表 cate_id
export function getNewsList(params) {
    return request({
        url: 'api/index/getNewsList',
        method: 'get',
        params
    })
}

//详情 new_id
export function getDetail(params) {
    return request({
        url: 'api/index/detail',
        method: 'get',
        params
    })
}

//搜索api/Index/search?type=&cate_id=&keyword=&sort=date&order=desc&page=
export function search(params) {
    return request({
        url: 'api/index/search',
        method: 'get',
        params
    })
}

//投诉建议
export function create(params) {
    return request({
        url: 'api/Commicate/create',
        method: 'post',
        params
    })
}

////////////////////////////////////文章管理//////////////////////////
//收藏文章 api/user/favoriteArticle
export function favoriteArticle(params) {
    return request({
        url: 'api/user/favoriteArticle',
        method: 'post',
        params
    })
}

//取消收藏文章 api/user/unfavoriteArticle
export function unfavoriteArticle(params) {
    return request({
        url: 'api/user/unfavoriteArticle',
        method: 'post',
        params
    })
}

// 删除收藏文章  api/user/delfavorite
export function delfavorite(params) {
    return request({
        url: 'api/user/delfavorite',
        method: 'post',
        params
    })
}

/////////////////////////报名//////////////////////////////////////////
//获得考试时间  api/bao/getExamTime
export function getExamTime() {
    return request({
        url: 'api/bao/getExamTime',
        method: 'get'
    })
}

//报名接口  api/bao/registerExam
export function registerExam(params) {
    return request({
        url: 'api/bao/registerExam',
        method: 'post',
        params
    })
}

// 考试报名协议 api/bao/agreement
export function agreement() {
    return request({
        url: 'api/bao/agreement',
        method: 'get'
    })
}

//考点查询 api/bao/address_list?keyword=深圳市
export function address_list(params) {
    return request({
        url: 'api/bao/address_list',
        method: 'get',
        params
    })
}

//考点申请  api/User/apply
export function apply(params) {
    return request({
        url: 'api/User/apply',
        method: 'post',
        params
    })
}

//学历列表  api/bao/edu_list
export function edu_list() {
    return request({
        url: 'api/bao/edu_list',
        method: 'get'
    })
}

//支付  api/Bao/pay
export function pay(params) {
    return request({
        url: 'api/Bao/pay',
        method: 'post',
        params
    })
}

//会员中心
export function record() {
    return request({
        url: 'api/user/record',
        method: 'get'
    })
}

//外语水平列表 api/bao/getForignList
export function getForignList() {
    return request({
        url: 'api/bao/getForignList',
        method: 'get'
    })
}

//普通话水平  api/bao/getPthList
export function getPthList() {
    return request({
        url: 'api/bao/getPthList',
        method: 'get'
    })
}

//学历列表 api/bao/edu_list
export function getEduList() {
    return request({
        url: 'api/bao/edu_list',
        method: 'get'
    })
}

//////////////////////////用户信息//////////////////////////////
//我的收藏   api/user/collect
export function collect() {
    return request({
        url: 'api/user/collect',
        method: 'get'
    })
}

//我的成绩 api/user/getExamResults
export function getExamResults(params) {
    return request({
        url: 'api/user/getExamResults',
        method: 'get',
        params
    })
}

//退出登录
export function loginOut(params) {
    return request({
        url: 'api/user/loginOut',
        method: 'get',
        params
    })
}

//我的报名  api/Bao/list
export function baoList(params) {
    return request({
        url: 'api/Bao/list',
        method: 'get',
        params
    })
}

//报名详情  api/bao/getRegistrationDetail?bao_id=1
export function getRegistrationDetail(params) {
    return request({
        url: 'api/bao/getRegistrationDetail',
        method: 'get',
        params
    })
}

//报名费
/*export function price_list() {
    return request({
        url: 'api/bao/price_list',
        method: 'get'
    })
}*/
// 科目列表
export function subjectLists(params) {
    return request({
        url: 'api/subject/lists',
        method: 'get',
        params
    })
}
// 支付宝支付pay_type=alipay&bao_id=69
export function submit(params) {
    return request({
        url: 'api/pay/submit',
        method: 'post',
        params
    })
}
//微信支付是否成功
export function check_status(params) {
    return request({
        url: 'api/pay/check_status',
        method: 'post',
        params
    })
}

//身份信息详情
export function searchCert(params) {
    return request({
        url: '/api/search/cert',
        method: 'get',
        params
    })
}
